goog.provide('el8.appchart.dialog.reconcileCdaImport');

goog.require('el8.appservice.notifier');
goog.require('el8.service.tz');
goog.require('el8.template.appchart.dialog.reconcileCdaImport');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.amplitude.ccdaImportHelpers');


/**
 * A dialog for selecting specific items from a list of potential
 * items found in CDA for import. This is used for all of the sections
 * except Demographics, which is a dictionary, rather than a list,
 * and has a more explicit notion of "before vs. after"
 */
el8.appchart.dialog.reconcileCdaImport = (function() {

    var callbackFn = null;
    var summaryId = null;
    var importJson = null;
    var sectionName = null;

    var that = new el8.uiwidget.NewDialog({
        width: 570,
        autoHeight: true,
        position: 'center'
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'save', 'Import & Reconcile', importCheckedItems, true
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.importable-checkbox',  function(e) {
            var $this = $(this);
            $this.closest('.importable-div').toggleClass('el8BlueHighlightList');

            e.stopPropagation(); // we don't need to trigger .importable-div after this

        }).on('click', '.importable-div',  function() {
            var $this = $(this);
            $this.toggleClass('el8BlueHighlightList');
            var checkBox = $this.find('input');
            checkBox.prop('checked', !checkBox.is(':checked')); //toggle the checkbox's state

        }).on('click', '.dc-med-trigger',  function() {
            var orderId = $(this).data('id');
            el8.appchart.dialog.ordermed.documentDiscontinue.show({
                order: el8.ptdata.fetchById(orderId),
                saveCallbackFn: renderList
            });
        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);

        summaryId = spec.summaryId;
        importJson = spec.importJson;
        callbackFn = spec.callbackFn || null;
        sectionName = spec.sectionName;

        renderList();

        that.setTitle('Proposed Reconciled ' + sectionName.capitalize() + ' List');
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);

        callbackFn = null;
        summaryId = null;
        importJson = null;
        sectionName = null;

        that.getContentElt().empty();
    };


    function renderList() {
        var soyDict = getItemsToDisplay();
        $.extend(soyDict, {
            sectionName: sectionName
        });
        that.setContent(
            el8.template.appchart.dialog.reconcileCdaImport.content(soyDict)
        );
    }

    function getItemsToDisplay() {
        var activeList = [];
        var inactiveList = [];

        if (sectionName === 'problems') {
            el8.ptdata.ptProblems.all().forEach(function(p) {
                var problemDict = {
                    'description': p.getDescription(),
                    'startDate': el8.service.tz.soyStr(p.getStartDate()),
                    'endDate': el8.service.tz.soyStr(p.getResolvedDate())
                };
                var list = (p.getStatus() === 'Active') ? activeList : inactiveList;
                list.push(problemDict);
            });
            importJson.forEach(function(p, index) {
                var problemDict = {
                    'description': p.description,
                    'startDate': p.startDate,
                    'endDate': p.resolvedDate,
                    'index': index
                };
                var list = (p.status === 'Active') ? activeList: inactiveList;
                list.push(problemDict);
            });

        } else if (sectionName === 'allergies') {
            el8.ptdata.ptAllergies.all().forEach(function(a) {
                var date = a.getStartDate() || a.getCreateDate();
                var allergyDict = {
                    'description': a.getAllergyName(),
                    'startDate': el8.service.tz.soyStr(date)
                };
                var list = (a.getStatus() === 'Active') ? activeList : inactiveList;
                list.push(allergyDict);
            });
            importJson.forEach(function(a, index) {
                var allergyDict = {
                    'description': a.allergenName,
                    'startDate': a.startDate,
                    'index': index
                };
                // status of 2 is Inactive in backend
                var list = (a.status === 2) ? inactiveList : activeList;
                list.push(allergyDict);
            });

        } else if (sectionName === 'medications') {
            el8.ptdata.medOrderThreads.all().forEach(function(t) {
                var order = t.getLatestOrder();
                // med order thread is for an draft rx if no order, skip
                if (!order) { return; }
                var description = order.getDisplayedMedicationName();
                if (order.getDirections()) { description += ' ' + order.getDirections(); }
                var medDict = {
                    'activeOrderId': t.isActive() ? order.getId() : null,
                    'description': description,
                    'startDate': el8.service.tz.soyStr(t.getStartDate()),
                    'endDate': el8.service.tz.soyStr(t.getDiscontinueDate())
                };
                var list = (t.isActive()) ? activeList : inactiveList;
                list.push(medDict);
            });
            importJson.forEach(function(t, index) {
                var order = t.orders[0];
                var dcOrder = t.dcs.length ? t.dcs[0] : null;
                var description = order.medicationName;
                if (order.directions) { description += ' ' + order.directions; }
                var medDict = {
                    'description': description,
                    'startDate': t.startDate,
                    'endDate': dcOrder ? dcOrder.dcDate : null,
                    'index': index
                };
                var list = (dcOrder) ? inactiveList : activeList;
                list.push(medDict);
            });

        } else if (sectionName === 'immunizations') {
            activeList = el8.ptdata.ptImmunizations.all().map(function(a) {
                return {
                    'description': a.getVaccineName() || a.getDescription(),
                    'startDate': el8.service.tz.soyStr(a.getAdministeredDate())
                };
            });
            activeList = activeList.concat(importJson.administered.map(function(a, index) {
                return {
                    'description': a.vaccine,
                    'startDate': a.administeredDate,
                    'index': 'a'+index
                };
            }));
            inactiveList = el8.ptdata.ptImmunizationDeclines.all().map(function(i) {
                return {
                    'description': i.getCdcType(),
                    'declinedDate': el8.service.tz.soyStr(i.getDeclinedDate())
                };
            });
            inactiveList = inactiveList.concat(importJson.declined.map(function(a, index) {
                return {
                    'description': a.cdcType,
                    'declinedDate': a.declinedDate,
                    'index': 'd'+index
                };
            }));
        }

        activeList = _.sortBy(activeList, function(item) { return item.description; });
        inactiveList = _.sortBy(inactiveList, function(item) { return item.description; });
        return {
            activeList: activeList,
            inactiveList: inactiveList
        };
    }

    function importCheckedItems() {
        var checkedInputs = $(':input[type="checkbox"]:checked', that.getContentElt());
        var checkedIndexes = [];
        checkedInputs.each(function(i, elt) {
            checkedIndexes.push($(elt).data('index'));
        });
        if (!checkedIndexes.length) { that.hide(); } // like cancelling if the user deselected everything
        el8.util.amplitude.logCcdaImportSection(sectionName);
        el8.appservice.notifier.notify('Importing data from patient summary...');
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('stageImportXmlSummary', [el8Globals.PATIENT_ID, summaryId, sectionName]),
            data: JSON.stringify({ indexes_to_import: checkedIndexes }),
            success: function(data) {
                if (callbackFn) { callbackFn(data); }
                el8.appservice.notifier.notify('Data from patient summary imported.');
                el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled();
                that.hide();
            }
        });

    }


    return that;

})();
